export enum StudentProgressExportFailReasonEnum {
  TimeExceeded = 'time_exceeded',
  RowsNotFound = 'rows_not_found',
  CancelledByUser = 'cancelled_by_user',
}
